/**
 * Main Resource Component
 */
export class MainResource {
    constructor() {
        // 기존 initMainResource 로직 유지
        if (typeof initMainResource === 'function') {
            initMainResource();
        }
    }
}

